import { initializeApp } from "firebase/app";
import { collection, getDocs, getFirestore } from "firebase/firestore";

const firebaseConfig = {
  apiKey: "AIzaSyD0Oqp4EaDrOZy3u4ZkuUwrq7nT1Blqo7Y",
  authDomain: "kudibase-project.firebaseapp.com",
  databaseURL: "https://kudibase-project.firebaseio.com",
  projectId: "kudibase-project",
  storageBucket: "kudibase-project.appspot.com",
  messagingSenderId: "791923025163",
  appId: "1:791923025163:web:ad98b15e75e907465a2e0e",
  measurementId: "G-L3ZQCMS1YM",
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

const database = getFirestore(app);

(async () => {
  // ---

  const buy = new Map();

  buy.set("amount", 0);

  const countriesList = [
    "United States",
    "South Korea",
    "Singapore",
    "Japan",
    "Canada",
    "United Kingdom",
    "Germany",
    "Australia",
    "Switzerland",
    "Netherlands",
    "Sweden",
    "Norway",
    "France",
    "Brazil",
    "India",
    "China",
    "Russia",
    "South Africa",
    "Mexico",
    "Argentina",
    "Turkey",
    "Italy",
    "Spain",
    "New Zealand",
    "Malaysia",
    "Nigeria",
    "Saudi Arabia",
    "United Arab Emirates",
    "Singapore",
  ];

  const GiftCardData = [
    "Amazon",
    "iTunes",
    "Steam",
    "Sephora",
    "Walmart",
    "Ebay",
    "One Vanilla",
    "Google Play",
    "Nord Storm",
    "Amex Gold",
    "VISA Gift Card",
    "Apple Store",
    "Nike",
    "Razer Gold",
    "Macy Gift Card",
    "Game Stop",
    "Xbox Gift Card",
    "Foot Locker",
    "Roblox GiftCard",
    "Best Buy GiftCard",
    "Kohl GiftCard",
    "Saks GiftCards",
    "Jc penny",
    "CVS Giftcards",
    "Target Giftcards",
    "Netspend Giftcard",
    "Dollar General Card",
    "Open Bucks Card",
    "Circle K Card",
    "Vanilla",
    "Paypal",
    "Green Dot Transfer",
    "GoBank",
    "Walmart Transfer",
    "Go2Bank",
    "Chime",
    "Money Lion",
    "Dave",
  ];

  const GiftCardCategoryData = [
    "No Receipt",
    "E Code",
    "Physical",
    "Cash Receipt",
    "Debit Receipt",
  ];

  /** Keep this method in sync with the backend**/
  const normalizeString = (str) => {
    const toBeReplaced = " ";
    const replaceWith = "_";
    // You need es2021 to use replaceAll
    // .replace(/[\W\s]|_/g, "") removes all character that are not aplha numeric
    return str.trim().toLowerCase().split(toBeReplaced).join(replaceWith);
  };

  /** Keep this method in sync with the backend. This should generate the same output as doc._id **/
  const generateGiftcardId = (category, name, country) => {
    const x = normalizeString;
    return `${x(String(name))}_${x(String(category))}_${x(String(country))}`;
  };

  const giftCards = new Map();

  const formEntry = new Map();

  const categories = new Set();

  const countries = new Set();

  const cardList = new Set();

  const querySnapshot = await getDocs(collection(database, "giftcards"));
  querySnapshot.forEach((doc) => {
    // ---
    // generateGiftcardId() should give the same output as doc_id

    const title = doc.data().title;
    const category = doc.data().category;
    const country = doc.data().country;
    const rate = doc.data().rate;

    giftCards.set(doc.id, {
      title,
      category,
      country,
      rate,
    });

    formEntry.set("categories", categories.add(category));

    formEntry.set("countries", countries.add(country));

    formEntry.set("giftcards", cardList.add(title));

    formEntry.set(normalizeString(title), {
      countries: formEntry.has(normalizeString(title))
        ? new Set([
            ...formEntry.get(normalizeString(title))["countries"],
            country,
          ])
        : new Set([country]),
      categories: formEntry.has(normalizeString(title))
        ? new Set([
            ...formEntry.get(normalizeString(title))["categories"],
            category,
          ])
        : new Set([category]),
    });
  });

  const giftCardSelect = document.getElementById("giftCard");
  const categorySelect = document.getElementById("category");
  const countrySelect = document.getElementById("country");
  const amountInput = document.getElementById("amount");
  const computedValue = document.getElementById("total-amount");

  if (giftCards.size === 0) {
    for (let i = 0; i < GiftCardData.length; i++) {
      const giftCardOption = document.createElement("option");
      giftCardOption.value = normalizeString(GiftCardData[i]);
      giftCardOption.textContent = GiftCardData[i];
      giftCardSelect.appendChild(giftCardOption);
    }

    for (let i = 0; i < GiftCardCategoryData.length; i++) {
      const categoryOption = document.createElement("option");
      categoryOption.value = normalizeString(GiftCardCategoryData[i]);
      categoryOption.textContent = GiftCardCategoryData[i];
      categorySelect.appendChild(categoryOption);
    }

    for (let i = 0; i < countriesList.length; i++) {
      const countryOption = document.createElement("option");
      countryOption.value = normalizeString(countriesList[i]);
      countryOption.textContent = countriesList[i];
      countrySelect.appendChild(countryOption);
    }
  } else {
    const _giftCards = Array.from(formEntry.get("giftcards"));
    const _giftCardSize = _giftCards.length;

    for (let i = 0; i < _giftCardSize; i++) {
      const giftCardOption = document.createElement("option");
      giftCardOption.value = normalizeString(_giftCards[i]);
      giftCardOption.textContent = _giftCards[i];
      giftCardSelect.appendChild(giftCardOption);
    }

    const _categories = Array.from(formEntry.get("categories"));
    const _categorySize = _categories.length;

    for (let i = 0; i < _categorySize; i++) {
      const categoryOption = document.createElement("option");
      categoryOption.value = normalizeString(_categories[i]);
      categoryOption.textContent = _categories[i];
      categorySelect.appendChild(categoryOption);
    }

    const _countries = Array.from(formEntry.get("countries"));
    const _countrySize = _countries.length;

    for (let i = 0; i < _countrySize; i++) {
      const countryOption = document.createElement("option");
      countryOption.value = normalizeString(_countries[i]);
      countryOption.textContent = _countries[i];
      countrySelect.appendChild(countryOption);
    }
  }

  giftCardSelect.addEventListener("change", function () {
    // Get the selected gift card
    const selectedGiftCard = normalizeString(giftCardSelect.value);

    // Populate the category select based on the selected gift card
    if (formEntry.has(selectedGiftCard)) {
      buy.set("giftcard", selectedGiftCard);
      // Clear the current options in the category and country select
      categorySelect.innerHTML = "";
      countrySelect.innerHTML = "";

      // Add a default option to the category select
      const categoryDefaultOption = document.createElement("option");
      categoryDefaultOption.value = "";
      categoryDefaultOption.textContent = "Select a Category";
      categorySelect.appendChild(categoryDefaultOption);

      const categoryArray = Array.from(
        formEntry.get(selectedGiftCard)["categories"],
      );
      for (let i = 0; i < categoryArray.length; i++) {
        const categoryOption = document.createElement("option");
        categoryOption.value = categoryArray[i];
        categoryOption.textContent = categoryArray[i];
        categorySelect.appendChild(categoryOption);
      }

      // Reset country select
      const countryDefaultOption = document.createElement("option");
      countryDefaultOption.value = "";
      countryDefaultOption.textContent = "Select a Country";
      countrySelect.appendChild(countryDefaultOption);

      const countryArray = Array.from(
        formEntry.get(selectedGiftCard)["countries"],
      );

      for (let i = 0; i < countryArray.length; i++) {
        const countryOption = document.createElement("option");
        countryOption.value = countryArray[i];
        countryOption.textContent = countryArray[i];
        countrySelect.appendChild(countryOption);
      }
    }

    const id = generateGiftcardId(
      buy.get("category"),
      buy.get("giftcard"),
      buy.get("country"),
    );
    if (giftCards.has(id)) {
      computedValue.value = giftCards.get(id) * buy.get("amount");
    }

    computedValue.value = 0;
  });

  categorySelect.addEventListener("change", function () {
    const selectedCategory = normalizeString(categorySelect.value);
    buy.set("category", selectedCategory);

    const id = generateGiftcardId(
      buy.get("category"),
      buy.get("giftcard"),
      buy.get("country"),
    );
    if (giftCards.has(id)) {
      computedValue.value = giftCards.get(id) * buy.get("amount");
    }

    computedValue.value = 0;
  });

  countrySelect.addEventListener("change", function () {
    const selectedCountry = normalizeString(countrySelect.value);
    buy.set("country", selectedCountry);

    const id = generateGiftcardId(
      buy.get("category"),
      buy.get("giftcard"),
      buy.get("country"),
    );
    if (giftCards.has(id)) {
      computedValue.value = giftCards.get(id) * buy.get("amount");
    }

    computedValue.value = 0;
  });

  amountInput.addEventListener("keyup", function () {
    const a = parseFloat(amountInput.value);

    if (!isNaN(a)) {
      buy.set("amount", a);

      const id = generateGiftcardId(
        buy.get("category"),
        buy.get("giftcard"),
        buy.get("country"),
      );

      if (giftCards.has(id)) {
        computedValue.value = giftCards.get(id)["rate"] * a;
      } else {
        computedValue.value = 1 * a;
      }
    } else {
      if (giftCards.has(id)) {
        computedValue.value = giftCards.get(id)["rate"] * 1;
      } else {
        computedValue.value = 0;
      }
    }
  });
})();
